import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import CardItem from "./CardItem";
import EmptyCard from "./EmptyCard";
import useWindowDimensions from "@/hooks/useWindowDimensions";

const FeaturedItem = () => {
  const dispatch = useDispatch();
  const { srpInitData } = useSelector((state) => state.srp);
  const { isGridOrList } = useSelector((state) => state.filter);
  const { width } = useWindowDimensions();

  // add length of filter items
  useEffect(() => {
    window?.scrollTo(0, 0);
  }, [dispatch, srpInitData?.srpTupples?.length]);

  const tupplePerPage = Math.floor(width / 350);
  const extraTupple =
    tupplePerPage - (srpInitData?.srpTupples?.length % tupplePerPage);

  const nearByComponent = () => {
    return (
      <>
        <div className="m0 srp-title-container mt30">
          <span className="srp-title">Nearby Properties</span>
        </div>
        <div className="m0 srp-result-font mb15">
          <span>{srpInitData?.nearbyOffset || srpInitData?.totalNearbyResultCount} Results</span>
        </div>
        {srpInitData.nearbySrpTupples.map((item, index) => (
          <CardItem
            key={item.propertyId}
            item={item}
            isGridOrList={isGridOrList}
            cardIndex={index}
          />
        ))}
        {extraTupple !== 4 &&
          !isGridOrList &&
          Array.from(Array(extraTupple).keys()).map((item) => (
            <div
              className={`col-md-6 col-lg-6 m10`}
              key={item}
              style={{ width: 350 }}
            />
          ))}
      </>
    );
  }
  return (
    <>
      {srpInitData?.srpTupples?.length > 0 ? (
        <>
          <>
            {srpInitData.srpTupples.map((item, index) => (
              <CardItem
                key={item.propertyId}
                item={item}
                isGridOrList={isGridOrList}
                cardIndex={index}
              />
            ))}
            {extraTupple !== 4 &&
              !isGridOrList &&
              Array.from(Array(extraTupple).keys()).map((item) => (
                <div
                  className={`col-md-6 col-lg-6 m10`}
                  key={item?.propertyId}
                  style={{ width: 350 }}
                />
              ))}
          </>
          {srpInitData?.nearbySrpTupples?.length > 0 && nearByComponent()}
        </>
      ) : srpInitData?.nearbySrpTupples?.length > 0 ? nearByComponent() : (
        <EmptyCard isGridOrList={isGridOrList} />
      )}
    </>
  );
};

export default FeaturedItem;
